module.exports = __webpack_public_path__ + "img/ResultsTypes_Agricultural_Demand.b8ae3faf.jpg";